import { Link } from "react-router-dom";
const AboutHost = () => {
  return <section
    id="about-host"
    className="relative isolate overflow-hidden bg-white py-16 sm:py-20 lg:py-28"
  >
            {
    /* Mobile Layout - sm and below */
  }
            <div className="lg:hidden container relative mx-auto flex flex-col gap-8 px-3 sm:px-5">
                {
    /* Label */
  }
                <span className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 px-3 py-2 font-mulish text-xs font-semibold uppercase tracking-[0.14em] text-amber-800 shadow-sm backdrop-blur w-fit">
                    Host-Nachricht
                </span>

                {
    /* Heading */
  }
                <h2 className="font-serif text-2xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-3xl">
                    Nachricht des Hosts und Gründers
                </h2>

                <p className="font-serif text-lg font-semibold tracking-[0.04em] text-[#1f4d3c] sm:text-xl">
                    Mit harmonischer Energie die tiefste Erholung schaffen
                </p>

                {
    /* Image */
  }
                <div className="relative overflow-hidden rounded-[24px] border border-white/70 bg-white shadow-lg">
                    <div className="relative w-full">
                        <img
    src="/images/Hiru/host.webp"
    alt="Host des Hiru Ayurveda Resorts beim Empfang"
    width={500}
    height={700}
    className="w-full h-auto object-contain" loading="lazy" />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/70 via-[#07130d]/15 to-transparent" />
                    </div>
                </div>

                {
    /* Content */
  }
                <div className="space-y-4">
                    <div className="space-y-4 font-mulish text-[15px] leading-7 text-gray-700 sm:text-base">
                        <p>
                            Ruwan Gallearachchi, Gründer von Hiru Ayurveda Resort, hat nach mehr als 22 Jahren Erfahrung in der Hospitality-Branche und mehreren Jahren Management in Ayurveda-Einrichtungen seine visionäre Idee eines echten Ayurveda-Paradieses verwirklicht.
                        </p>
                        <div className="rounded-[24px] border border-amber-200/70 bg-white/75 p-5 shadow-lg backdrop-blur-sm">
                            <p className="font-mulish text-sm leading-7 text-[#475569]">
                                „Im Laufe der Jahre habe ich viel gelernt und wundervolle Begegnungen erlebt. Auf all diesen Erfahrungen aufbauend haben wir mit einem vertrauensvollen Team mit Herz und Hingabe diesen Ort geschaffen. Durch die Weisheit des echten Ayurveda möchte ich, dass Sie hier wieder zu innerer Ruhe finden und neue Erkenntnisse für Ihr Leben entdecken. Wie die Sonne bringen wir Wärme und Herzlichkeit mit und empfangen Sie als Teil unserer Familie.“
                            </p>
                            <p className="mt-3 text-right font-serif text-base font-semibold text-[#1f4d3c]">
                                —— Ruwan Gallearachchi
                            </p>
                        </div>
                        <p>
                            Die Geschichte begann mit Hiru Villa und hat sich heute zu fünf einzigartigen „Heimaten“ erweitert. Obwohl jedes Resort seinen eigenen Charakter hat, bleibt überall dieselbe Herzlichkeit des Personals und die erstklassige Behandlung durch erfahrene Ärzte erhalten.
                        </p>
                        <p>
                            Bis zu dem Moment, an dem Sie Ihre ursprüngliche Leuchtkraft wiederfinden, begleiten wir Sie mit echter Fürsorge und Herzlichkeit.
                        </p>
                    </div>

                    <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                        <div className="rounded-full border border-emerald-200 bg-[#f8fcf7] px-3 py-1.5 font-mulish text-xs sm:text-sm font-medium text-[#24422f] shadow-sm">
                            Host
                        </div>
                        <div className="rounded-full border border-emerald-200 bg-[#f8fcf7] px-3 py-1.5 font-mulish text-xs sm:text-sm font-medium text-[#24422f] shadow-sm">
                            Ruwan Gallearachchi
                        </div>
                        <Link
    to="https://hiru-ayurveda-resorts.com/en/hiru-villa/"
    target="_blank"
    rel="noreferrer"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-4 py-2 font-mulish text-xs sm:text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                            Hiru Villa ansehen
                        </Link>
                    </div>
                </div>
            </div>

            {
    /* Desktop Layout - lg and above */
  }
            <div className="hidden lg:grid container relative mx-auto gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-14 lg:px-8">
                <div>
                    <span className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 px-4 py-2 font-mulish text-xs font-semibold uppercase tracking-[0.14em] text-amber-800 shadow-sm backdrop-blur md:text-sm">
                        Host-Nachricht
                    </span>

                    <h2 className="mt-5 max-w-2xl font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Nachricht des Hosts und Gründers
                    </h2>

                    <p className="mt-4 font-serif text-2xl font-semibold tracking-[0.04em] text-[#1f4d3c] sm:text-[2rem]">
                        Mit harmonischer Energie die tiefste Erholung schaffen
                    </p>

                    <div className="mt-6 space-y-5 font-mulish text-base leading-8 text-gray-700 lg:text-lg">
                        <p>
                            Ruwan Gallearachchi, Gründer von Hiru Ayurveda Resort, hat nach mehr als 22 Jahren Erfahrung in der Hospitality-Branche und mehreren Jahren Management in Ayurveda-Einrichtungen seine visionäre Idee eines echten Ayurveda-Paradieses verwirklicht.
                        </p>
                        <div className="rounded-[28px] border border-amber-200/70 bg-white/75 p-6 shadow-[0_18px_50px_rgba(120,92,47,0.08)] backdrop-blur-sm sm:p-7">
                            <p className="font-mulish text-sm leading-8 text-[#475569] sm:text-base">
                                „Im Laufe der Jahre habe ich viel gelernt und wundervolle Begegnungen erlebt. Auf all diesen Erfahrungen aufbauend haben wir mit einem vertrauensvollen Team mit Herz und Hingabe diesen Ort geschaffen. Durch die Weisheit des echten Ayurveda möchte ich, dass Sie hier wieder zu innerer Ruhe finden und neue Erkenntnisse für Ihr Leben entdecken. Wie die Sonne bringen wir Wärme und Herzlichkeit mit und empfangen Sie als Teil unserer Familie.“
                            </p>
                            <p className="mt-4 text-right font-serif text-lg font-semibold text-[#1f4d3c] sm:text-xl">
                                —— Ruwan Gallearachchi
                            </p>
                        </div>
                        <p>
                            Die Geschichte begann mit Hiru Villa und hat sich heute zu fünf einzigartigen „Heimaten“ erweitert. Obwohl jedes Resort seinen eigenen Charakter hat, bleibt überall dieselbe Herzlichkeit des Personals und die erstklassige Behandlung durch erfahrene Ärzte erhalten.
                        </p>
                        <p>
                            Bis zu dem Moment, an dem Sie Ihre ursprüngliche Leuchtkraft wiederfinden, begleiten wir Sie mit echter Fürsorge und Herzlichkeit.
                        </p>
                    </div>

                    <div className="mt-8 flex flex-wrap items-center gap-4">
                        <div className="rounded-full border border-emerald-200 bg-[#f8fcf7] px-4 py-2 font-mulish text-sm font-medium text-[#24422f] shadow-sm">
                            Host
                        </div>
                        <div className="rounded-full border border-emerald-200 bg-[#f8fcf7] px-4 py-2 font-mulish text-sm font-medium text-[#24422f] shadow-sm">
                            Ruwan Gallearachchi
                        </div>
                        <Link
    to="https://hiru-ayurveda-resorts.com/en/hiru-villa/"
    target="_blank"
    rel="noreferrer"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-6 py-3 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                            Hiru Villa ansehen
                        </Link>
                    </div>
                </div>

                <div className="relative">
                    <div className="absolute -left-6 top-8 hidden h-28 w-28 rounded-full border border-white/70 lg:block" />
                    <div className="absolute -right-4 bottom-10 hidden h-20 w-20 rounded-full border border-white/70 lg:block" />

                    <div className="relative overflow-hidden rounded-[32px] border border-white/70 bg-white shadow-[0_30px_90px_rgba(16,38,26,0.18)]">
                        <div className="relative w-full">
                            <img
    src="/images/Hiru/host.webp"
    alt="Host des Hiru Ayurveda Resorts, der Gäste willkommen heißt"
    width={600}
    height={900}
    className="w-full h-auto object-contain" loading="lazy" />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/70 via-[#07130d]/15 to-transparent" />
                        </div>

                        <div className="absolute inset-x-4 bottom-4 rounded-[22px] border border-white/20 bg-white/15 px-5 py-4 text-white shadow-lg backdrop-blur-md sm:inset-x-6">
                            <p className="font-mulish text-xs uppercase tracking-[0.18em] text-white/75">Gründer</p>
                            <p className="mt-2 font-serif text-2xl font-semibold sm:text-[2rem]">Ruwan Gallearachchi</p>
                            <p className="mt-1 font-mulish text-sm text-white/85">Hiru Ayurveda Resort</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default AboutHost;
